import axios from "axios";
import { toast } from "react-toastify";

const isAuth = localStorage.getItem("futToken");

export const api = axios.create({
  baseURL: `${import.meta.env.VITE_APP_API_URL}`,
  headers: {
    ...(isAuth && { Authorization: `Bearer ${localStorage.getItem("futToken")}` }),
  },
});

export const apiPublic = axios.create({
  baseURL: `${import.meta.env.VITE_APP_API_URL}`,
});

// api.interceptors.response.use(
//   (response) => {
//     return response;
//   },
//   (error) => {
//     if (error.response?.status === 401) {
//       localStorage.removeItem("futToken");
//       window.location.replace("/login");
//       return;
//     }
//     return Promise.reject(error);
//   }
// );
